module.exports = __webpack_public_path__ + "img/home-compare.d987e14.png";